import React, { Component } from 'react';
import UserService from '../service/UserService';
import * as CommonUtils from "../util/CommonUtils";
import {OrangeButton} from "./common/ButtonsConstants";
import {AddCircleTwoTone} from "@material-ui/icons";
import {generateSignedTnC} from "../util/ApiUtils";
import { t } from '../i18n';

class Account extends Component {

    constructor(props) {
        super(props);
        this.state = {
            users: [],
            message: null
        };
        this.refreshUsers = this.refreshUsers.bind(this);
        this.exportReport = this.exportReport.bind(this);
    }

    componentDidMount() {
        this.refreshUsers();
    }

    exportReport() {
        generateSignedTnC();
    }

    refreshUsers() {
        UserService.retrieveAllUsers()
            .then(
                response => {
                    console.log(response);
                    this.setState({ users: response.data })
                }
            )
    }

    render() {
        return (
            <div className="container">
                <h3>{ t('account.title') }</h3>
                <OrangeButton
                    variant="contained"
                    color="secondary"
                    startIcon={<AddCircleTwoTone />}
                    size="small"
                    onClick={this.exportReport}
                    style={{ marginTop: '20px', marginBottom: '20px', marginLeft: '20px', float: "left" }}
                >
                    { t('account.export') }
                 </OrangeButton>
                <div className="container">
                    <table className="table">
                        <thead>
                        <tr>
                            <th>{ t('account.table.id') }</th>
                            <th>{ t('account.table.name') }</th>
                            <th>{ t('account.table.email') }</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.users.map(
                                user =>
                                    <tr key={user.id}>
                                        <td>{user.name}</td>
                                        <td>{user.email}</td>
                                    </tr>
                            )
                        }
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
}

export default Account;